"use client";

import { cn } from "@/lib/utils";
import { KineticText } from "@/components/typography";

interface AnimatedSectionHeaderProps {
  title: string;
  subtitle?: string;
  className?: string;
  align?: "left" | "center";
  eyebrow?: string;
  kineticTrigger?: "inView" | "mount";
}

export function AnimatedSectionHeader({
  title,
  subtitle,
  className,
  align = "center",
  eyebrow,
  kineticTrigger = "inView",
}: AnimatedSectionHeaderProps) {
  return (
    <div
      className={cn(
        "mb-8 md:mb-12",
        align === "center" && "text-center",
        className
      )}
    >
      {eyebrow && (
        <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary">
          <KineticText text={eyebrow} mode="chars" stagger={0.03} trigger={kineticTrigger} />
        </p>
      )}
      <h2 className="font-display text-3xl md:text-4xl font-bold text-primary mb-3">
        <KineticText text={title} mode="words" stagger={0.05} delay={0.08} trigger={kineticTrigger} />
      </h2>
      {subtitle && (
        <p className="text-muted text-base md:text-lg max-w-2xl mx-auto">
          <KineticText text={subtitle} mode="words" stagger={0.02} delay={0.25} trigger={kineticTrigger} />
        </p>
      )}
    </div>
  );
}
